export const Role = {
    Admin: 'Administrator',
    Distribuitor: 'Distribuitor',
    Customer: 'Customer',
    Warehouse: 'Warehouse'
}